import { object, string } from "yup"
import { useValidatorSeeker } from "@app"

import { userSettingProvidersFormData } from "../@signals"


const schema = object({
	color: string().required('Color is required'),
	id_provider: string().required('Provider is required'),
})

export default function useUserSettingsProviderValidator() {
	const { isValid, errors } = useValidatorSeeker(userSettingProvidersFormData.value, schema)

	return {
		isValid,
		colorError: errors.name || null,
		providerError: errors.id_provider || null
	}
}